var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 50,
    viewBox: "0 0 96 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 49,
    width: 94,
    height: 48,
    rx: 4,
    transform: "rotate(-180 95 49)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.2521 25.7071C79.6426 25.3166 79.6426 24.6834 79.2521 24.2929L72.8882 17.9289C72.4976 17.5384 71.8645 17.5384 71.4739 17.9289C71.0834 18.3195 71.0834 18.9526 71.4739 19.3431L77.1308 25L71.4739 30.6569C71.0834 31.0474 71.0834 31.6805 71.4739 32.0711C71.8645 32.4616 72.4976 32.4616 72.8882 32.0711L79.2521 25.7071ZM17.4541 26L78.545 26V24L17.4541 24V26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.ebe628182df4efc4c24f7fbd64c2c76b.svg";
export { ForwardRef as ReactComponent };